import AxiosInstance from '../axios.js';

const BASE = '/promotions';

function cleanParams(params = {}) {
    const out = {};
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') out[key] = value;
    });
    return out;
}

export default {
    listPromotions(params = {}) {
        return AxiosInstance.get(BASE, { params: cleanParams(params) });
    },
    createPromotion(payload) {
        return AxiosInstance.post(BASE, payload);
    },
    checkPublicSlugAvailability(params = {}) {
        return AxiosInstance.get(`${BASE}/public-slug/availability`, { params: cleanParams(params) });
    },
    uploadImage(file, maxFileSize = 10) {
        const formData = new FormData();
        formData.append('file', file);
        return AxiosInstance.post('/object-storages', formData, {
            params: { maxFileSize },
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },
    getPromotion(promotionId) {
        return AxiosInstance.get(`${BASE}/${promotionId}`);
    },
    updatePromotion(promotionId, payload) {
        return AxiosInstance.patch(`${BASE}/${promotionId}`, payload);
    },
    activatePromotion(promotionId) {
        return AxiosInstance.post(`${BASE}/${promotionId}/activate`);
    },
    pausePromotion(promotionId) {
        return AxiosInstance.post(`${BASE}/${promotionId}/pause`);
    },
    closePromotion(promotionId) {
        return AxiosInstance.post(`${BASE}/${promotionId}/close`);
    },
    deletePromotion(promotionId) {
        return AxiosInstance.delete(`${BASE}/${promotionId}`);
    },
    listEntries(promotionId, params = {}) {
        return AxiosInstance.get(`${BASE}/${promotionId}/entries`, { params: cleanParams(params) });
    },
    exportEntries(promotionId, payload = {}) {
        return AxiosInstance.post(`${BASE}/${promotionId}/entries/export`, payload, { responseType: 'blob' });
    },
    getEntry(promotionId, entryId) {
        return AxiosInstance.get(`${BASE}/${promotionId}/entries/${entryId}`);
    },
    deleteEntry(promotionId, entryId) {
        return AxiosInstance.delete(`${BASE}/${promotionId}/entries/${entryId}`);
    },
    deleteEntries(promotionId, entryIds = []) {
        return AxiosInstance.post(`${BASE}/${promotionId}/entries/bulk-delete`, { entryIds });
    },
    listMessageLogs(promotionId, params = {}) {
        return AxiosInstance.get(`${BASE}/${promotionId}/message-logs`, { params: cleanParams(params) });
    },
    resendMessageLog(promotionId, logId) {
        return AxiosInstance.post(`${BASE}/${promotionId}/message-logs/${logId}/resend`);
    },
    listCouponSlots(promotionId, params = {}) {
        return AxiosInstance.get(`${BASE}/${promotionId}/coupon-slots`, { params: cleanParams(params) });
    },
    getCustomCouponInventory(params = {}) {
        return AxiosInstance.get(`${BASE}/custom-coupons/inventory`, { params: cleanParams(params) });
    },
    listCustomCouponPools() {
        return AxiosInstance.get(`${BASE}/custom-coupons/pools`);
    },
    listCustomCoupons(promotionId, params = {}) {
        return AxiosInstance.get(`${BASE}/${promotionId}/custom-coupons`, { params: cleanParams(params) });
    },
    sendTestMessage(promotionId, payload) {
        return AxiosInstance.post(`${BASE}/${promotionId}/test-message`, payload);
    },
};
